import { combineReducers } from 'redux';
import { auth } from './auth';
import { alert } from './alert';
import { reviews } from './reviews';
import { feedbacks } from './feedbacks';
import { analytics } from './analytics';
import { account } from './account';
import { google } from './google';
import { replyTemplates } from './reply-templates';
import { autoreplyRules } from './autoreply-rules';
import { surveys } from './surveys';
import { keywords } from './keywords';
import { themes } from './themes';
import { contacts } from './contacts';
import { channels } from './channels';
import { campaigns } from './campaigns';
import { automations } from './automations';
import { campaignTemplates } from './campaign-templates';
import { menus } from './menus';
import { microsites } from './microsites';
import { forms } from './forms';
import { dashboard } from './dashboard';
import { ifood } from './ifood';
import { conversations } from './conversations';
import { inbox } from './inbox';
import { sendInvitesUi } from './send-invites-ui';
import { coverManager } from './coverManager';
import { facebook } from './facebook';
import { linkedin } from './linkedin';
import { socialPosts } from './social-posts';
import { pricingDrawerUi } from './pricing-drawer-ui';
import { inboxTemplates } from './inbox-templates';
import { labels } from './labels';
import { conversationTags } from './conversation-tags';
import { profiles } from './profiles';
import { profilesMedia } from './profiles-media';
import { countries } from './countries';
import { notifications } from './notifications';
import { knowledgeBase } from './knowledge-base';
import { brands } from './brands';
import { vtex } from './vtex';
import { locationsProfiles } from './locationsProfiles';
import { agents } from './agents';
import { agentsLookup } from './agents-lookup';
import { coupons } from './coupons';

const rootReducer = combineReducers({
    auth,
    reviews,
    feedbacks,
    alert,
    analytics,
    account,
    google,
    replyTemplates,
    autoreplyRules,
    surveys,
    keywords,
    themes,
    contacts,
    channels,
    campaigns,
    automations,
    campaignTemplates,
    menus,
    microsites,
    forms,
    dashboard,
    ifood,
    conversations,
    inbox,
    sendInvitesUi,
    coverManager,
    facebook,
    linkedin,
    socialPosts,
    pricingDrawerUi,
    inboxTemplates,
    labels,
    conversationTags,
    profiles,
    profilesMedia,
    countries,
    notifications,
    knowledgeBase,
    brands,
    vtex,
    locationsProfiles,
    agents,
    agentsLookup,
    coupons,
});

export default rootReducer;
